import { Icon, IconName, Stack } from '@optimus-web/core';
import { LocalizedText, useSafeContext, useScope } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { WithAccountId, WithBillId } from '@mews-commander/types';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import { getBillName, getUniqueBillOwnerIdsByBillIds } from '@mews-commander/legacy-entities/src/ducks';
import { useCommanderSelector, useCommanderThunkDispatch } from '@mews-commander/utils';
import { AssociateCurrentOwnerContext } from '../context';
import { getAmountDue } from '../../../selectors';
import {
    canAssociateCurrentOwner,
    getSelectedItemsUniqueBillIds,
    moveItemsCloseDialog,
} from '../../../ducks/itemAssignment';
import { BillListItem, InlineBalance } from '../../../components';

interface BillItemItemAssignmentProps extends WithBillId, WithAccountId {
    deleteEmptyBills: (targetBill?: string) => void;
    isCurrentAccount?: boolean;
}
export const BillItemItemAssignment = ({
    billId,
    accountId,
    deleteEmptyBills,
    isCurrentAccount,
}: BillItemItemAssignmentProps) => {
    const dispatch = useCommanderThunkDispatch();
    const { associateCurrentOwner } = useSafeContext(AssociateCurrentOwnerContext);
    const scope = useScope() ?? '';
    const amount = useCommanderSelector((state) =>
        getAmountDue(state, { billIds: [billId], enterpriseId: getCurrentEnterpriseId() })
    );

    const name = useCommanderSelector((state) => getBillName(state, { id: billId }));

    const itemBillIds = useCommanderSelector((state) => getSelectedItemsUniqueBillIds(state, scope));
    const uniqueBillOwners = useCommanderSelector((state) =>
        getUniqueBillOwnerIdsByBillIds(state, { ids: itemBillIds })
    );

    const canAssociateOwner =
        canAssociateCurrentOwner({ uniqueBillOwners, targetAccountId: accountId }) && !isCurrentAccount;

    const moveItems = () => {
        dispatch(
            moveItemsCloseDialog({
                targetBillId: billId,
                scope,
                associateCurrentOwner: canAssociateOwner ? associateCurrentOwner : false,
                deleteEmptyBills,
            })
        );
    };

    return (
        <BillListItem
            onClick={moveItems}
            primaryText={name}
            data-move-items-row={billId}
            secondaryText={<InlineBalance amount={amount} />}
            rightIcon={
                <Stack spacing="200" itemAlignment="center">
                    <LocalizedText textKey={TextKey.MoveItemsHere} />
                    <Icon value={IconName.ArrowRight} />
                </Stack>
            }
        />
    );
};
